import React, { useState } from "react";
import PropTypes from "prop-types";
import { Column, Control, Label, Input } from "rbx";
import { SystemCodeSelect } from "../../../components/inputs";
import FilterButtons from "../../../components/FilterButtons";

const INITIAL_FILTER_STATE = {
  VehicleNumber_contains: null,
  VehicleTypeRecIdRef: null
};

function SystemCodeFilters({ filters, onFilter, onClose }) {
  const [inputs, setInputs] = useState({ ...filters });

  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setInputs({ ...inputs, [e.target.name]: value });
  };

  const handleClose = () => onClose(onFilter(inputs));
  const handleReset = () => onClose(onFilter({ ...INITIAL_FILTER_STATE }));
  const handleCancel = () => onClose(onFilter(filters));

  return (
    <div className="inspection-modal-container">
      <Column.Group>
        <Column>
          <Control>
            <Label>Vehicle Number</Label>
            <Input
              name="VehicleNumber_contains"
              type="text"
              value={inputs.VehicleNumber_contains}
              onChange={handleChange}
            />
          </Control>
        </Column>
        <Column>
          <Control expanded>
            <SystemCodeSelect
              icon="truck"
              label="Vehicle Type"
              lookup={{ Category: "Fleet", Code: "VehicleType" }}
              name="VehicleTypeRecIdRef"
              showHelp={false}
              value={inputs.VehicleTypeRecIdRef}
              onChange={handleChange}
            />
          </Control>
        </Column>
      </Column.Group>
      <hr />
      <FilterButtons
        handleCancel={handleCancel}
        handleClose={handleClose}
        handleReset={handleReset}
      />
    </div>
  );
}
SystemCodeFilters.propTypes = {
  filters: PropTypes.object,
  onFilter: PropTypes.func,
  onClose: PropTypes.func
};

export default SystemCodeFilters;
